import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from 'OpsCenter/shared/shared.module';
import {MerchantBulkCreateComponent} from "OpsCenter/ops-support/merchant-bulk-create/merchant-bulk-create.component";
import {MerchantBulkCreateService} from "OpsCenter/ops-support/merchant-bulk-create/merchant-bulk-create.service";


@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule],
  declarations: [MerchantBulkCreateComponent],
  providers: [MerchantBulkCreateService],
  entryComponents: [MerchantBulkCreateComponent],
})
export class MerchantBulkCreateModule {
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.module.ts